<template>
  <normal-table
    ref="taskTable"
    class="contract-detector-list"
    :table-col="tableCol"
    :table-data="list"
    :first-table-col="firstTableCol"
    :operate-col="operateCol"
    :operator="operator"
    :show-edit="true"
    :paging="paging"
    @pagination="handleSizeOrPageChange"
  >
    <template slot="status" slot-scope="{ param }">
      <span class="task-status" :class="param.row.Status | transStatusClass">{{ param.row.Status | transStatus($constants.EMPTY) }}</span>
    </template>
  </normal-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isNumber } from '@/utils/common'

export default {
  name: 'SolidityTaskList',
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == -1) {
        return '任务异常'
      } else if (value == 0) {
        return '创建成功'
      } else if (value == 1) {
        return '正在运行'
      } else if (value == 2) {
        return '任务成功'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == -1) {
        return 'is-failed'
      } else if (value == 0) {
        return 'is-create'
      } else if (value == 1) {
        return 'is-running'
      } else if (value == 2) {
        return 'is-success'
      } else {
        return ''
      }
    }
  },
  props: {
    contractId: {
      type: [String, Number],
      default: undefined
    }
  },
  data() {
    return {
      tableCol: [
        { 
          prop: 'ID', 
          label: '任务ID', 
          minWidth: 92 
        },
        { 
          prop: 'ContractID', 
          label: '合约ID', 
          minWidth: 67 
        },
        { 
          prop: 'ContractFilename', 
          label: '合约文件名', 
          minWidth: 163 
        },
        { 
          prop: 'ContractName', 
          label: '合约函数名', 
          minWidth: 104 
        },
        { 
          prop: 'Status', 
          label: '状态', 
          slotName: 'status', 
          minWidth: 108
        },
        {
          prop: 'CreatedAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row.CreatedAt)
          }, 
          minWidth: 156
        },
        {
          prop: 'StartedAt',
          label: '开始时间',
          formatter: row => {
            return this.formatTime(row.StartedAt)
          }, 
          minWidth: 156
        },
        {
          prop: 'FinishedAt',
          label: '结束时间',
          formatter: row => {
            return this.formatTime(row.FinishedAt)
          }, 
          minWidth: 156
        },
        {
          prop: 'CostSec',
          label: '运行耗时',
          formatter: row => {
            return this.timeLengthFormat(row.CostSec)
          }, 
          minWidth: 105
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          isText: false,
          icon: 'icon-check',
          class: 'operate-check'
        },
        {
          text: '重新运行',
          isText: false,
          click: (row, col, cellValue) => {
            if (row.Status == -1 || row.Status == 2) {
              return this.popConfirmRestart(row)
            } else {
              this.$message({
                type: 'info',
                message: '任务正在运行中!'
              })
            }
          },
          icon: 'icon-refresh',
          class: 'operate-refresh'
        }
      ],
      operateCol: {
        minWidth: 63
      },
      firstTableCol: {
        select: false,
        type: 'selection'
      },
      paging: {
        total: 0,
        offset: 0,
        limit: 10
      },
      list: []
    }
  },
  mounted() {},
  methods: {
    ...mapActions([]),
    getList(limit = 20, offset = 0, keywords = '', onlyUnfinished = false) {
      let params = {
        limit: limit,
        offset: offset
      }

      if (isNumber(keywords) || !isNaN(parseInt(keywords))) {
        params.contract_id = parseInt(keywords)
      } else {
        params.contract_filename = keywords
      }
      let apiName = 'getSolidityDetectTaskList'
      if (onlyUnfinished) {
        apiName = 'getSolidityUnfinishedTaskList'
      }
      let self = this
      this.$apis.contractdetector[apiName](params).then(res => {
        if (res && res.data && res.code === 1) {
          self.list = res.data.items
          self.paging.total = res.data.total
          self.paging.offset = res.data.offset
          self.paging.limit = res.data.limit
        } else {
          self.list = []
          self.paging.total = 0
          self.paging.offset = 0
        }
        // console.log(res)
      })
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit, this.contractId)
    },
    formatTime(time) {
      if (time) {
        return this.$utils.dateFormat('YYYY-mm-dd HH:MM', new Date(time))
      } else {
        return this.$constants.EMPTY
      }
    },
    timeLengthFormat(value) {
      if (!isNumber(value) || isNaN(value) || value < 0) return this.$constants.EMPTY
      var secondTime = parseInt(value) // 秒
      var minuteTime = 0 // 分
      var hourTime = 0 // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(secondTime) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }

      return result
    },
    goDetail(row) {
      this.$emit('goDetail', row)
    },
    popConfirmRestart(row) {
      this.$emit('popConfirmRestart', row)
    },
    refresh(keywords, onlyUnfinished) {
      this.getList(this.paging.limit, this.paging.offset, keywords, onlyUnfinished)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('normal-table-wrap', (
  --contract-detector-list-status-create: #45c2ff,
  --contract-detector-list-status-running: #fac20a,
  --contract-detector-list-status-success: #55DA62,
  --contract-detector-list-status-failed: #e95757,
), (
  --contract-detector-list-status-create: #45c2ff,
  --contract-detector-list-status-running: #fac20a,
  --contract-detector-list-status-success: #55DA62,
  --contract-detector-list-status-failed: #e95757,
));
.normal-table-wrap {
  @include adaptation(
    (
      --contract-detector-list-unavailable-height: 111px
    )
  );
  --contract-detector-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--contract-detector-list-unavailable-height)
  );
  height: 100%;
  min-height: var(--contract-detector-list-min-height);

  /deep/ {
    .el-empty {
      height: 100%;
      min-height: var(--contract-detector-list-min-height);
    }


    .normal-table {
      height: 100%;
      min-height: var(--contract-detector-list-min-height);

      .functions-display {
        .functions-tags {
          display: flex;
          flex-wrap: wrap;

          .el-tag {
            margin: var(--base-size-3);
          }
        }
      }

      .task-status {
        &.is-create {
          color: var(--contract-detector-list-status-create);
        }

        &.is-success {
          color: var(--contract-detector-list-status-success);
        }

        &.is-failed {
          color: var(--contract-detector-list-status-failed);
        }

        &.is-running {
          color: var(--contract-detector-list-status-running);
        }
      }

      .el-table__body tr .el-table__cell .cell .operate-cell .operate-item {

        &.operate-refresh {
          color: var(--base-color-success);
        }
      }
    }
  }
}
</style>
